module.exports = __webpack_public_path__ + "img/Course-costume.a1b82506.jpg";